// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3wAOp","info":"PatientInfo_info__mjQXT"};